<template>
  <div class="copyright-wrap">
    <div class="b">
      <ul class="nav">
        <li v-for="(link,i) in links" :key='i'>
          <a :href="link.link" target="_blank">{{link.name}}</a>
        </li>
      </ul>
      <div class="copyright">
	      <a href="http://beian.miit.gov.cn/" target="_blank">备案号：辽ICP备16011035号-2</a>
		  <a style="padding-left:10px;padding-right:10px;" href="https://www.haibaoguoji.com/static/images/yyzz.jpg" target="_blank">营业执照</a>
		  <a href="https://www.haibaoguoji.com/static/images/idc.jpg" target="_blank">电信增值业务许可证</a>
		  <a style="padding-left:10px;padding-right:10px;" href="https://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">
			  <img src="https://www.haibaoguoji.com/static/images/gab.jpg" style="width:16px;" />辽公网安备21021202000203
		  </a>
	    </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props:{
    links:{
      type:Array,
      default:function(){
        return []
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.copyright-wrap {
  width: 100%;
  background: #fafafa;
  .b {
    position: relative;
    min-width: 100%;
    padding: 30px 0;
    ul {
      display: flex;
      justify-content: center;
      padding: 16px 0;
      li {
        border-right: 1px solid #666;
        &:last-of-type {
          border: none;
        }
        a {
          display: block;
          padding: 0 8px;
          font-size: 12px;
          color: rgba(102, 102, 102, 1);
          text-align: center;
        }
      }
    }
    .copyright {
      margin: 0 auto;
      height: 12px;
      font-size: 12px;
      text-align: center;
      color: rgba(153, 153, 153, 1);
    }
  }
}
</style>